import { NpFeatureCarouselSection } from "src/components/np-design/sections/feature-carousel/NpFeatureCarouselSection"
import { useProductContext } from "./context"

export const ProductGalleries = () => {
  const { carousels } = useProductContext()

  if (!carousels?.length) {
    return null
  }

  return (
    <>
      {carousels.map((carousel, index) => (
        <NpFeatureCarouselSection key={index} heading={carousel.heading} slides={carousel.slides} />
      ))}
    </>
  )
}
